<template>
  <SogCard>
    <SogCardTitle>
      {{ productTypeName(_current.baseProductType) }}
    </SogCardTitle>
    <SogCardContent>
      <SogFlexRow style="justify-content: left">
        <ProductPriceButtonComponent
          v-for="productPrice in _current.productPrices"
          v-show="productPrice"
          :key="productPrice"
          :product-price="productPrice"
          :visible-price="!_isBranch"
          @click="onSelectProductPrice(productPrice)"
        />
      </SogFlexRow>
    </SogCardContent>
  </SogCard>
</template>

<script setup lang="ts">

import {productTypeName} from "@/shared/model/productType";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import ProductPriceButtonComponent from "@/modules/ShoppingCart/components/ProductPriceButtonComponent.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import {storeToRefs} from "pinia";
import {computed} from "vue";
import {useAccountStore} from "@/stores/accountStore";
import ProductPrice from "@/shared/model/productPrice";


const _shoppingCartStore = useShoppingCartStore();
const {currentItem: _current} = storeToRefs(_shoppingCartStore);
const _accountStore = useAccountStore();


const _isBranch = computed(() => {
  return _accountStore.person && _accountStore.person.isBranch();
});

async function onSelectProductPrice(price: ProductPrice) {
  await _shoppingCartStore.setProductPrice(price);
}


</script>

<style scoped>

</style>
